<template>
  <div class="container">
    <div class="extended-resources-container">
      <div class="markdown">
        <vue3-markdown-it
          v-for="contentBlock in pageContents"
          :source="contentBlock.text"
          :key="contentBlock.id"
        />
      </div>
      <!-- <h1>Extended Resources</h1>
      <h4>This is where extended resources will live.</h4> -->
    </div>
  </div>
</template>
<script>
import { getPageContent } from "@/services/PageService.js";
export default {
  name: "ExtendedResources",
  data() {
    return {
      pageContents: [
        // {
        //   order: Number,
        //   id: Number,
        //   text: String,
        //   image: String,
        // },
      ],
    };
  },
  computed: {},
  methods: {
    fetchPageContents() {
      getPageContent("Extended Resources")
        .then((theData) => {
          this.pageContents = theData;
        })
        .catch((err) => {
          console.log(
            "Oh noes, something went wrong getting page contents: ",
            err
          );
        });
    },
  },
  mounted() {
    this.fetchPageContents();
  },
};
</script>
<style scoped>
.extended-resources-container {
  max-width: 60rem;
  margin: 0 auto;
  padding-top: 2rem;
}
</style>
